export default __webpack_public_path__ + "static/media/slide-16.b5085d53.png";